module.exports = __webpack_public_path__ + "img/help.d05e7a81.svg";